// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeModeProvider } from './contexts/ThemeModeContext';
import { FeatureFlagsProvider } from './contexts/FeatureFlagsContext';

// Lock fonts (avoid swaps in production)
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

// Register service worker for caching and offline support (skip on localhost to avoid stale development caches)
if ('serviceWorker' in navigator && window.location.hostname !== 'localhost') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
} else if ('serviceWorker' in navigator && window.location.hostname === 'localhost') {
  // Active unregistration of any leftover service workers on localhost
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeModeProvider>
      <CssBaseline />
      <FeatureFlagsProvider>
        <App />
      </FeatureFlagsProvider>
    </ThemeModeProvider>
  </React.StrictMode>
);
